import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105f0853"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-wrapper" }
const _hoisted_2 = { class: "register-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"margin-top":"24px","padding-bottom":"24px"}
}
const _hoisted_4 = { class: "help-file-wrapper" }
const _hoisted_5 = { style: {"margin":"24px auto 20px"} }
const _hoisted_6 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_7 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_8 = { style: {"width":"500px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = { class: "content-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "预备名称", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-title" }, [
  /*#__PURE__*/_createTextVNode(" 系统内名称 "),
  /*#__PURE__*/_createElementVNode("span", null, " 注：提交2个名称")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "form-title",
  style: {"margin-top":"0"}
}, [
  /*#__PURE__*/_createTextVNode(" 工商注册名称 "),
  /*#__PURE__*/_createElementVNode("span", null, " 注：提交5个名称")
], -1))
const _hoisted_14 = {
  key: 1,
  style: {"padding-left":"10px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name",
  style: {"margin-bottom":"20px"}
}, "系统内开设公司", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 注：填写大写首拼字母，如北京公司，填写：BJGS ", -1))
const _hoisted_17 = {
  key: 1,
  class: "margin-bottom border-bottom"
}
const _hoisted_18 = {
  key: 2,
  class: "flow-box"
}

import {
  onMounted,
  ref,
  reactive,
  computed,
  withDefaults,
  createVNode,
} from "vue";
import type { FormInstance } from "ant-design-vue";
import { USERLIST } from "../../const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";

import Approval from "@/components/Approval.vue";
import RegisterInfo from "@/components/RegisterInfo1.vue";
import CheckCompany from "@/components/CheckCompany1.vue";
import {
  GetFilterRegions,
  MatchPrefixCode,
  GetCity,
  GetFilterStaff,
} from "@/api/api";
import { useRouter, useRoute } from "vue-router";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

import { watch, watchEffect } from "vue";
import { useStore } from "vuex";
import { approve } from "../../api/openapply";
import { GetCurrentMyPageList } from "@/api/index";

import { FileType, NodeItem } from "../../types/procss";
import {
  checkNameDetail,
  submitCheckNameApply,
  editCheckNameApply,
  recallCheckNameApply,
  companyAccountDetail,
  submitCompanyAccountApply,
  editCompanyAccountApply,
  recallCompanyAccountApply,
} from "../../api/process_company";
import { message, Modal } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const route = useRoute();
const { query } = route;
const id = ref(query.id || "");
const refresh = ref<boolean>(false);
const currentStep = ref<number>(0);
const firstIn = ref<boolean>(true);

let validateInfos = Array.from({ length: 2 }, () => "");

let registerInfos = Array.from({ length: 5 }, () => "");
const checkFormRef = ref<FormInstance>();

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);
const WorkFlowId = ref<number>(0);
const store = useStore();

const personInfo = computed(() => store.getters.getSimpleInfo);
let actionButtons = ref<string[]>([]);

const displayRender = (val: any) => {
  return val.labels[val.labels.length - 1];
};

const allStaff = ref<
  {
    value: string;
    label: string;
  }[]
>([]);

const allRegions = ref<
  {
    value: string;
    label: string;
  }[]
>([]);
const allCity = ref<
  {
    value: string;
    label: string;
  }[]
>([]);

onMounted(() => {
  getCityData("");
  getRegions();
});
// 选定城市
const citysChange = (val, option) => {
  form.value.LocationCode = val && val[val.length - 1];
  if (option.length > 1) {
    let Text = option
      .map((item: any) => {
        return item.Text;
      })
      .join("");
    form.value.LocationName = Text;
  } else {
    form.value.LocationName = option[option.length - 1].Text;
  }
};
const filterOption = (input: string, option: any) => {
  return option.label.indexOf(input) >= 0;
};
watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;
      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value = currentData.value?.Code == "401" ? 0 : 1;
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "4");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value = currentData.value?.Code == "401" ? 0 : 1;
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);
const handleTabChange = async (index: number) => {
  reEdit.value = false;
  //编辑
  if (index == 0) {
    BranchCompanyFlowId.value = filterCompanyCode("401");
    await getCheckNameDetail();
  } else if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("402");
    await getCompanyAccountDetail();
  }
};

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});


let checkForm = ref({
  SystemNames: validateInfos,
  HmBusRegisterNames: registerInfos,
});
// 获取所有职员
const getStaff = async (value: string) => {
  allStaff.value = [];
  const { Data, Success, Message } = await GetFilterStaff({
    SearchWords: value,
  });
  if (Success) {
    Data.forEach((r: any) => {
      allStaff.value.push({
        value: r.Val,
        label: r.Key,
      });
    });
  }
};
// 获取所有归属大区
const getRegions = async () => {
  allRegions.value = [];
  const { Data, Success, Message } = await GetFilterRegions({
    KeyWord: "",
  });
  if (Success) {
    Data.forEach((r: any) => {
      allRegions.value.push({
        value: r.Val,
        label: r.Key,
      });
    });
  } else {
    message.warning(Message);
  }
};

// 获取城市数据
const getCityData = async (city: string) => {
  const { Data, Success, Message } = await GetCity({
    KeyWord: city,
  });
  if (Success) {
    allCity.value = Data.Citys;
  } else {
    message.warning(Message);
  }
};
// const getCityData = async (city: string) => {
//   allCity.value = [];
//   const { Data, Success, Message } = await GetCity({
//     KeyWord: city,
//   });

//   if (Success) {
//     Data.forEach((r: any) => {
//       allCity.value.push({
//         value: r.Val,
//         label: r.Key,
//       });
//     });
//   } else {
//     message.warning(Message);
//   }
// };

let form = ref({
  CompanyName: "",
  FullName: "",
  Quanpin: "",
  Shoupin: "",
  ManagerStaffId: 0,
  ManagerStaffName: "",
  PrefixCode: "",
  StationNumber: "",
  LegalStaffId: "",
  LegalStaffName: "",
  LocationCode: "",
  LocationName: "",
  RegionName: "",
  RegionId: 0,
});

const recallVisible = ref<boolean>(false);
const recallResume = ref<string>("");
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识
const edit = computed(() => actionButtons.value.includes("100"));

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "集团人力篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184438187882144_集团人力篇.pdf",
  },
];

const tableData = [
  {
    depart: "总经办",
    name: "纪银红",
    duty: "全流程咨询",
    email: "Jan.Ji@risfond.com",
    phone: "18810273871",
  },
  {
    depart: "人力发展中心",
    name: "李慧",
    duty: "开设系统账号审批、员工调动审批",
    email: "lihui1@risfond.com",
    phone: "18612393319",
  },
];
const list = ["提交系统内名称以及工商注册名称", "申请在系统内开设公司"];
//详情
const getCheckNameDetail = async () => {
  const { Data } = await checkNameDetail({
    Id: BranchCompanyFlowId.value,
  });
  WorkFlowId.value = Data?.WorkFlowId;
  if (Data?.PageData.HmBusRegisterNames.length > 0) {
    checkForm.value = Data?.PageData;
  }
  actionButtons.value = Data?.ActionButtons || [];
};
//提交申请
const checkNameApply = () => {
  checkFormRef.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await submitCheckNameApply({
      PageData: checkForm.value,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const filterCompanyCode = (code: string) => {
  WorkFlowId.value = 0;
  const { type, id } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    preData.value = props.flowData.find(
      (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
    );
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};
//撤回申请
const submiRecallCheckNameApply = async () => {
  if (!recallResume.value) {
    message.error("请输入撤回理由");
    return;
  }
  let method = recallCheckNameApply;
  let callback = checkNameDetail;
  if (currentStep.value == 1) {
    method = recallCompanyAccountApply;
    callback = getCompanyAccountDetail;
  }
  const { Success, Message } = await method({
    Reason: recallResume.value,
    BusinessFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("已撤回申请");
    callback();
    $emit("update-flow");
    recallVisible.value = false;
  } else {
    message.error(Message || "撤回失败，请稍后重试");
    handleCancelResume();
  }
};

//重新提交
const submitEditCheckNameApply = async () => {
  checkFormRef.value?.validateFields().then(async (res) => {
    const { Success, Message } = await editCheckNameApply({
      PageData: checkForm.value,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.success(Message || "提交失败，请稍后重试");
    }
  });
};

//详情
const getCompanyAccountDetail = async () => {
  const { Data } = await companyAccountDetail({
    Id: BranchCompanyFlowId.value,
  });
  form.value = Data?.PageData || {};
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId;
};
//提交申请
const companyAccountApply = () => {
  checkFormRef.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await submitCompanyAccountApply({
      PageData: form.value,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

//重新提交
const submitEditCompanyAccountApply = async () => {
  checkFormRef.value?.validateFields().then(async (res) => {
    const { Success, Message } = await editCompanyAccountApply({
      PageData: form.value,
      BranchCompanyFlowId: BranchCompanyFlowId.value,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.success(Message || "提交失败，请稍后重试");
    }
  });
};
const handleCancelResume = () => {
  recallResume.value = "";
};

const handleReSubmit = () => {
  //重新提交申请x
  if (currentStep.value == 0) {
    submitEditCheckNameApply();
  } else if (currentStep.value == 1) {
    submitEditCompanyAccountApply();
  }
};

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    //提交申请
    if (currentStep.value == 0) {
      checkNameApply();
    } else if (currentStep.value == 1) {
      companyAccountApply();
    }
  } else if (buttonType == "101") {
    //撤回申请
    recallVisible.value = true;
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    applyOnOkVisible.value = true;
    //通过
    // Modal.confirm({
    //   content: "您确认要通过审核吗？",
    //   icon: createVNode(ExclamationCircleOutlined),
    //   onOk() {
    //     pass();
    //   },
    //   style: {
    //     top: "30%",
    //   },
    //   cancelText: "取消",
    //   onCancel() {
    //     Modal.destroyAll();
    //   },
    // });
  } else if (buttonType == "-1") {
    if (currentStep.value == 0) {
      getCheckNameDetail();
    } else if (currentStep.value == 1) {
      getCompanyAccountDetail();
    }
    reEdit.value = false;
  } else if (buttonType == "-2") {
    handleReSubmit();
  }
};

const handleChange = (val: string) => {
  const _item = allRegions.value.find((item) => item.value == val);
  form.value.RegionId = val || "";
  form.value.RegionName = _item?.label || "";
};

const handleStaffChange = (val: string) => {
  const _item = allStaff.value.find((item) => item.value == val);
  form.value.LegalStaffId = val || "";
  form.value.LegalStaffName = _item?.label || "";
};
const handleVpChange = (val: string) => {
  const _item = allStaff.value.find((item) => item.value == val);
  form.value.ManagerStaffId = val || "";
  form.value.ManagerStaffName = _item?.label || "";
};

const handleCityChange = (val: string) => {
  form.value.LocationName = val || "";
};

const handleInput = async (e) => {
  const { Data } = await MatchPrefixCode({
    // Shoupin: e.target.value,
    // CompanyName: form.value.CompanyName,
    CompanyName: e.target.value,
  });
  form.value.Shoupin = Data.ShouPin || "";
  form.value.Quanpin = Data.QuanPin || "";
  form.value.PrefixCode = Data.ShouCode || "";
};
//通过审核
const pass = async () => {
  const { Success } = await approve({
    Description: "",
    WorkflowId: WorkFlowId.value,
    Status: 1, //1:通过 2: 驳回
  });
  if (Success) {
    message.success("提交成功");
    $emit("update-flow");
    getList();
    refresh.value = !refresh.value;
  } else {
    message.success("提交失败");
  }
  Modal.destroyAll();
};
const handleRejectback = () => {
  rejectedVisible.value = false;
  $emit("update-flow");
  getList();
  refresh.value = !refresh.value;
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "开设公司账号流程" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 250,
          height: 70
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "开设公司账号注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_steps, {
                  class: "open-steps",
                  current: currentStep.value,
                  "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((currentStep).value = $event)),
                  size: "small",
                  onChange: handleTabChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_step, {
                      title: "核名",
                      status: currentStep.value == 0 ? 'process' : 'wait'
                    }, null, 8, ["status"]),
                    _createVNode(_component_a_step, {
                      title: "开设系统账号",
                      status: currentStep.value == 1 ? 'process' : 'wait'
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                }, 8, ["current"])
              ]),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (currentStep.value == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: {"padding-left":"10px"},
                      class: _normalizeClass(
              (currentData.value && currentData.value.State == 1) || reEdit.value
                ? ''
                : 'border-bottom'
            )
                    }, [
                      _hoisted_11,
                      (
                (id.value &&
                  _unref(personInfo).IsCreate == 0 &&
                  _unref(checkForm).SystemNames.length == 0) ||
                WorkFlowId.value == 0 ||
                reEdit.value
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_12,
                            _createVNode(_component_a_form, {
                              class: "check-form-wrapper",
                              ref_key: "checkFormRef",
                              ref: checkFormRef,
                              model: _unref(checkForm),
                              trigger: "blur"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkForm).SystemNames, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_form_item, {
                                    class: "check-form-item",
                                    label: " ",
                                    rules: [
                    { required: true, message: '请输入系统内名称' },
                    {
                      max: 50,
                    },
                  ],
                                    name: ['SystemNames', index],
                                    key: index,
                                    colon: false
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(checkForm).SystemNames[index],
                                        "onUpdate:value": ($event: any) => ((_unref(checkForm).SystemNames[index]) = $event)
                                      }, null, 8, ["value", "onUpdate:value"])
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]))
                                }), 128)),
                                _hoisted_13,
                                _createVNode(_component_a_form_item, {
                                  class: "check-form-item",
                                  style: {"margin-bottom":"0"}
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkForm).HmBusRegisterNames, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_form_item, {
                                    class: "check-form-item",
                                    label: " ",
                                    required: "",
                                    key: index,
                                    name: ['HmBusRegisterNames', index],
                                    colon: false,
                                    rules: [
                    { required: true, message: '请输入工商注册名称' },
                    {
                      max: 50,
                    },
                  ],
                                    placeholder: "请输入"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(checkForm).HmBusRegisterNames[index],
                                        "onUpdate:value": ($event: any) => ((_unref(checkForm).HmBusRegisterNames[index]) = $event)
                                      }, null, 8, ["value", "onUpdate:value"])
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["model"])
                          ], 64))
                        : (_openBlock(), _createBlock(CheckCompany, {
                            key: 1,
                            "folw-id": BranchCompanyFlowId.value,
                            detail: _unref(checkForm)
                          }, null, 8, ["folw-id", "detail"]))
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      (
                (id.value &&
                  _unref(personInfo).IsCreate == 0 &&
                  _unref(checkForm).SystemNames.length == 0) ||
                WorkFlowId.value == 0 ||
                reEdit.value
              )
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            class: _normalizeClass(["register-form-wrapper", 
                  currentData.value && currentData.value.State > 1 && !reEdit.value
                    ? 'border-bottom'
                    : ''
                ]),
                            ref_key: "checkFormRef",
                            ref: checkFormRef,
                            model: _unref(form),
                            layout: "inline",
                            trigger: "change"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "公司全称",
                                class: "register-form-item",
                                name: "FullName",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).FullName,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).FullName) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公司简称",
                                class: "register-form-item",
                                name: "CompanyName",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).CompanyName,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).CompanyName) = $event)),
                                    placeholder: "请输入",
                                    onInput: handleInput
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公司简称全拼",
                                class: "register-form-item",
                                name: "Quanpin",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: "",
                                    value: _unref(form).Quanpin,
                                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).Quanpin) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公司VP姓名",
                                class: "register-form-item",
                                name: "ManagerStaffName",
                                colon: false,
                                required: "",
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _unref(form).ManagerStaffName,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).ManagerStaffName) = $event)),
                                    "show-search": "",
                                    placeholder: "请输入",
                                    "default-active-first-option": false,
                                    "show-arrow": false,
                                    "filter-option": false,
                                    "not-found-content": null,
                                    options: allStaff.value,
                                    onSearch: getStaff,
                                    onChange: handleVpChange
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公司简称首拼",
                                class: "register-form-item shoupin",
                                name: "Shoupin",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                    { required: true, message: '' },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: "",
                                    value: _unref(form).Shoupin,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).Shoupin) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"]),
                                  _hoisted_16
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公司首编码",
                                class: "register-form-item",
                                name: "PrefixCode",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    disabled: "",
                                    value: _unref(form).PrefixCode,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).PrefixCode) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "工位数量",
                                class: "register-form-item",
                                name: "StationNumber",
                                required: "",
                                colon: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).StationNumber,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).StationNumber) = $event)),
                                    placeholder: "请输入"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "法人",
                                class: "register-form-item",
                                name: "LegalStaffName",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _unref(form).LegalStaffName,
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).LegalStaffName) = $event)),
                                    "show-search": "",
                                    placeholder: "请输入",
                                    "default-active-first-option": false,
                                    "show-arrow": false,
                                    "filter-option": false,
                                    "not-found-content": null,
                                    options: allStaff.value,
                                    onSearch: getStaff,
                                    onChange: handleStaffChange
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "所在城市",
                                class: "register-form-item",
                                name: "LocationName",
                                colon: false,
                                required: "",
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_cascader, {
                                    class: "citys",
                                    value: _unref(form).LocationName,
                                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).LocationName) = $event)),
                                    options: allCity.value,
                                    placeholder: "选定城市",
                                    "expand-trigger": "hover",
                                    "show-arrow": false,
                                    pacement: "bottomLeft",
                                    "display-render": displayRender,
                                    props: { emitPath: false, value: 'Id', label: 'Text' },
                                    fieldNames: {
                      label: 'Text',
                      value: 'Id',
                      children: 'Childs',
                    },
                                    onChange: citysChange
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "所属大区",
                                class: "register-form-item",
                                name: "RegionName",
                                required: "",
                                colon: false,
                                rules: [
                    {
                      max: 50,
                    },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _unref(form).RegionName,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).RegionName) = $event)),
                                    placeholder: "请输入所属大区",
                                    "show-search": "",
                                    "show-arrow": false,
                                    options: allRegions.value,
                                    "filter-option": filterOption,
                                    onChange: handleChange
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["class", "model"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(RegisterInfo, {
                              detail: _unref(form),
                              "folw-id": BranchCompanyFlowId.value
                            }, null, 8, ["detail", "folw-id"])
                          ]))
                    ])),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        id: WorkFlowId.value,
                        refresh: refresh.value
                      }, null, 8, ["id", "refresh"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_a_modal, {
              class: "modal-dialog",
              bodyStyle: {
          width: '460px',
          height: '216px',
        },
              visible: recallVisible.value,
              "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((recallVisible).value = $event)),
              title: "撤回理由",
              onOk: submiRecallCheckNameApply,
              onCancel: handleCancelResume
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  style: {"height":"163px","padding-left":"0"},
                  value: recallResume.value,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((recallResume).value = $event)),
                  bordered: false,
                  placeholder: "请填写撤回理由",
                  maxlength: 100,
                  "auto-size": { minRows: 5, maxRows: 5 }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(actionButtons).length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": _unref(actionButtons),
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})